import _ from 'lodash';
import * as actions from '../redux/constants';
import * as dashboardsService from '../core/dashboards';
import { getIndividualStudentGradebook } from '../core/lms';
import { updateSearchParamsInBrowser } from '../utils/util';

export const updateIndividualStudentGradebook = (isgData) => (dispatch) => {
  dispatch({
    type: actions.UPDATE_INDIVIDUAL_STUDENT_GRADEBOOK,
    payload: isgData,
  });
};

export const openIndividualStudentGradebook = (studentId) => (dispatch) => {
  dispatch({
    type: actions.OPEN_INDIVIDUAL_STUDENT_GRADEBOOK,
    payload: { studentId },
  });
};

export const selectIndividualStudent = (student) => (dispatch) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set('studentId', student.studentId);
  updateSearchParamsInBrowser(searchParams);
  dispatch({
    type: actions.SET_INDIVIDUAL_STUDENT_GRADEBOOK,
    payload: { currentStudent: student },
  });
};

export const closeIndividualStudentGradebook = () => async (dispatch) => {
  dispatch({
    type: actions.CLOSE_INDIVIDUAL_STUDENT_GRADEBOOK,
    payload: null,
  });
};

export const getIndividualStudentData =
  (courseId, studentId, showLoader = true) =>
  async (dispatch) => {
    try {
      if (showLoader) {
        dispatch({
          type: actions.INDIVIDUAL_STUDENT_GRADEBOOK_LOADING,
          payload: true,
        });
      }

      const [timeOnTaskUserData, studentGradebookResponse] = await Promise.all([
        dashboardsService.getTimeOnTaskByCourseAndUser(courseId, studentId),
        getIndividualStudentGradebook(courseId, studentId),
      ]);

      const timeOnTaskMap = _.keyBy(timeOnTaskUserData, 'assignment_id');

      const categoriesDataWithTimeOnTask = _.map(
        studentGradebookResponse.categoriesData,
        (categoryGroup) => {
          const assignments = categoryGroup.assignments?.map((assignment) => {
            const timeOnTaskInMins =
              timeOnTaskMap[assignment.id]?.time_on_assignment_in_mins;
            return timeOnTaskInMins !== undefined
              ? { ...assignment, timeOnTaskInMins }
              : assignment;
          });
          return {
            ...categoryGroup,
            assignments,
            unfilteredAssignments: assignments,
          };
        },
      );

      const studentGradebook = {
        categoriesData: categoriesDataWithTimeOnTask,
        course: studentGradebookResponse.course,
        studentPerformanceData: studentGradebookResponse.studentPerformanceData,
      };

      dispatch({
        type: actions.GET_INDIVIDUAL_STUDENT_GRADEBOOK_DATA,
        payload: { timeOnTaskUserData, studentGradebook },
      });
      dispatch({
        type: actions.INDIVIDUAL_STUDENT_GRADEBOOK_LOADING,
        payload: false,
      });
    } catch (error) {
      dispatch({
        type: actions.INDIVIDUAL_STUDENT_GRADEBOOK_LOADING,
        payload: false,
      });

      throw error;
    }
  };
